// extracted by mini-css-extract-plugin
export default {"sellerInfoButton":"HmC5p"};